/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_iupac_input_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IUPAC motif`)
};

const es_iupac_input_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motivo IUPAC`)
};

const de_iupac_input_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IUPAC-Motiv`)
};

const nl_iupac_input_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IUPAC-motief`)
};

const fr_iupac_input_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motif IUPAC`)
};

const it_iupac_input_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motivo IUPAC`)
};

const pt_br2_iupac_input_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motivo IUPAC`)
};

const pt_iupac_input_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motivo IUPAC`)
};

const ja_iupac_input_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IUPACモチーフ`)
};

const zh_iupac_input_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IUPAC 模体`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const iupac_input_label = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.iupac_input_label(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("iupac_input_label", locale)
	if (locale === "en") return en_iupac_input_label(inputs)
	if (locale === "es") return es_iupac_input_label(inputs)
	if (locale === "de") return de_iupac_input_label(inputs)
	if (locale === "nl") return nl_iupac_input_label(inputs)
	if (locale === "fr") return fr_iupac_input_label(inputs)
	if (locale === "it") return it_iupac_input_label(inputs)
	if (locale === "pt-BR") return pt_br2_iupac_input_label(inputs)
	if (locale === "pt") return pt_iupac_input_label(inputs)
	if (locale === "ja") return ja_iupac_input_label(inputs)
	return zh_iupac_input_label(inputs)
};